export default "__VITE_ASSET__DfZfYWAN__"